import React from "react";

/* ── Asset imports ── */
import HeroBgImg         from "../../asset/images/news/SMPSvsTraditionalHero-bg.webp";
import ArticleImg        from "../../asset/images/news/article-26.webp";
import YoutubeIcon       from "../../asset/images/news/icon-youtube.svg";
import LinkedinIcon      from "../../asset/images/news/icon-linkedin.svg";
import BcSepIcon         from "../../asset/images/news/breadcrumb-separator.svg";
import ProfileIcon       from "../../asset/images/news/icon-profile.svg";
import CalendarIcon      from "../../asset/images/news/icon-calendar.svg";
import ClockIconImg      from "../../asset/images/news/icon-clock.svg";
import CommentsIcon      from "../../asset/images/news/icon-comments.svg";
import PreviousIcon      from "../../asset/images/news/icon-previous.svg";
import NextIcon          from "../../asset/images/news/icon-next.svg";
import FacebookIcon      from "../../asset/images/news/icon-facebook.svg";
import TwitterIcon       from "../../asset/images/news/icon-twitter.svg";
import LinkedinShareIcon from "../../asset/images/news/icon-linkedin-share.svg";

/* ── Recent post thumbnails ── */
import RecentImg1 from "../../asset/images/news/news-1.webp";
import RecentImg2 from "../../asset/images/news/news-2.webp";
import RecentImg3 from "../../asset/images/news/news-3.webp";
import RecentImg4 from "../../asset/images/news/news-4.webp";

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .svt { font-family: 'Poppins', sans-serif; font-size: 14px; color: #202020; background: #fff; }

  /* ══ HERO (no border-top) ══ */
  .svt-hero {
    position: relative; width: 100%; height: 460px;
    overflow: hidden;
  }
  .svt-hero-bg {
    position: absolute; inset: 0;
    width: 100%; height: 100%;
    object-fit: cover; object-position: center right; display: block;
  }
  .svt-hero-overlay {
    position: absolute; inset: 0;
    // background: linear-gradient(
    //   to right,
    //   rgba(0,0,0,0.85) 0%,
    //   rgba(0,0,0,0.65) 38%,
    //   rgba(0,0,0,0.10) 100%
    // );
  }
  .svt-hero-content {
    position: absolute; inset: 0;
    display: flex; flex-direction: column; justify-content: center;
    padding: 0 102px;
    max-width: 1600px; margin: 0 auto; left: 0; right: 0;
  }
  .svt-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px; font-weight: 600; color: #fff;
    line-height: 120%; margin-bottom: 15px; max-width: 520px;
  }
  .svt-hero-divider {
    width: 479px; height: 2px;
    background: #EB2019; border: none; margin-bottom: 15px;
  }
  .svt-hero-subtitle {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #fff;
    line-height: 160%; max-width: 479px;
  }

  /* ══ BREADCRUMB ══ */
  .svt-breadcrumb { width: 100%; padding: 40px 0 0 0; }
  .svt-breadcrumb-inner {
    max-width: 1600px; margin: 0 auto; padding: 0 102px;
    display: flex; align-items: center; flex-wrap: wrap;
  }
  .svt-bc-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 500; color: #202020;
    text-decoration: none; display: flex; align-items: center; gap: 14px;
    transition: color 0.15s;
  }
  .svt-bc-item:hover { color: #EB2019; }
  .svt-bc-sep {
    display: flex; align-items: center; justify-content: center;
    width: 24px; height: 24px; border-radius: 50%;
    margin: 0 8px; flex-shrink: 0;
  }
  .svt-bc-sep img { width: 24px; height: 24px; display: block; }
  .svt-bc-item.active { color: #202020; font-weight: 500; }

  /* ══ INNER ══ */
  .svt-inner { max-width: 1600px; margin: 0 auto; padding: 0 102px; }

  /* ══ MAIN ══ */
  .svt-main-section { padding: 80px 0 120px 0; }
  .svt-main-row { display: flex; align-items: flex-start; gap: 89px; }

  /* ══ ARTICLE ══ */
  .svt-article { flex: 1; min-width: 0; }

  .svt-meta-bar {
    display: flex; align-items: center; flex-wrap: wrap; gap: 20px;
    margin-bottom: 30px;
  }
  .svt-meta-item {
    display: flex; align-items: center; gap: 8px;
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    border-right: 1px solid #7A7A7A; padding-right: 15px;
  }
  .svt-meta-item:last-child { border-right: none; padding-right: 0; }
  .svt-meta-item img { width: 24px; height: 24px; display: block; flex-shrink: 0; }

  .svt-article-title {
    font-family: 'Poppins', sans-serif;
    font-size: 32px; font-weight: 600; color: #202020;
    line-height: 140%; margin-bottom: 30px;
  }

  .svt-article-img {
    width: 100%; height: 450px;
    object-fit: cover; border-radius: 10px;
    display: block; margin: 45px 0 30px 0;
  }

  .svt-article-body {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }
  .svt-article-body p { margin-bottom: 20px; }
  .svt-article-body p:last-child { margin-bottom: 0; }

  .svt-h2 {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 600; color: #202020;
    margin: 0px 0 15px 0; line-height: 160%; display: block;
  }

  .svt-h3 {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 600; color: #202020;
    margin: 20px 0 10px 0; line-height: 160%; display: block;
  }

  /* Bullet list */
  .svt-article-body ul {
    list-style: none; margin: 0 0 30px 0; padding: 0;
    display: flex; flex-direction: column; gap: 15px;
  }
  .svt-article-body ul li {
    display: flex; align-items: flex-start; gap: 10px;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }
  .svt-article-body ul li::before {
    content: '•'; color: #202020;
    font-size: 16px; line-height: 160%; flex-shrink: 0;
  }
  .svt-article-body ul li > span { flex: 1; }

  .svt-article-body strong { font-weight: 600; color: #202020; }

  .svt-red-link { color: #EB2019; text-decoration: underline; font-weight: 600; }
  .svt-red-link:hover { opacity: 0.8; }
  .svt-red-link-plain { color: #EB2019; text-decoration: underline; font-weight: 400; }
  .svt-red-link-plain:hover { opacity: 0.8; }

  /* Hashtags */
  .svt-hashtags {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%; margin-top: 15px;
  }

  /* ══ BOTTOM ROW ══ */
  .svt-bottom-row {
    display: flex; align-items: center; justify-content: space-between;
    margin-top: 30px; padding-top: 30px;
    border-top: 1px solid #C7C7C7; flex-wrap: wrap; gap: 16px;
  }
  .svt-bottom-nav { display: flex; align-items: center; gap: 60px; }
  .svt-nav-btn {
    display: inline-flex; align-items: center; gap: 20px;
    font-family: 'Poppins', sans-serif;
    font-size: 20px; font-weight: 500; color: #202020;
    text-decoration: none; background: none; border: none;
    cursor: pointer; transition: color 0.15s;
  }
  .svt-nav-btn:hover { color: #EB2019; }
  .svt-nav-btn img { width: 40px; height: 40px; display: block; }

  .svt-share-icons { display: flex; align-items: center; gap: 20px; }
  .svt-share-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 50%;
    text-decoration: none; flex-shrink: 0; transition: opacity 0.15s;
  }
  .svt-share-icon:hover { opacity: 0.85; }
  .svt-share-icon img { width: 44px; height: 44px; display: block; }

  /* ══ SIDEBAR ══ */
  .svt-sidebar { flex: 0 0 475px; }
  .svt-sidebar-block { margin-bottom: 60px; }
  .svt-sidebar-title {
    font-family: 'Poppins', sans-serif;
    font-size: 24px; font-weight: 600; color: #202020;
    margin-bottom: 30px; padding-bottom: 20px;
    border-bottom: 1px solid #EB2019; line-height: 120%;
  }
  .svt-recent-list { display: flex; flex-direction: column; gap: 30px; }
  .svt-recent-item {
    display: flex; align-items: flex-start; gap: 12px;
    text-decoration: none; color: #202020;
  }
  .svt-recent-item:hover .svt-recent-title { color: #EB2019; }
  .svt-recent-img {
    flex: 0 0 200px; height: 120px;
    object-fit: cover; border-radius: 6px; display: block;
  }
  .svt-recent-body { flex: 1; min-width: 0; }
  .svt-recent-title {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%; transition: color 0.15s;
    display: -webkit-box; -webkit-line-clamp: 3;
    -webkit-box-orient: vertical; overflow: hidden;
  }
  .svt-social-icons { display: flex; align-items: center; gap: 30px; }
  .svt-social-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 6px; overflow: hidden;
    text-decoration: none; transition: opacity 0.15s;
  }
  .svt-social-icon:hover { opacity: 0.8; }
  .svt-social-icon img { width: 44px; height: 44px; object-fit: contain; display: block; }

  /* ══ RESPONSIVE — TABLET ══ */
  @media (max-width: 768px) {
    .svt-hero             { height: 350px; }
    .svt-hero-content     { padding: 0 32px; }
    .svt-hero-title       { font-size: 30px; }
    .svt-hero-divider     { width: 100%; max-width: 479px; }
    .svt-breadcrumb       { padding: 24px 0 0 0; }
    .svt-breadcrumb-inner { padding: 0 32px; }
    .svt-inner            { padding: 0 32px; }
    .svt-main-section     { padding: 48px 0 60px 0; }
    .svt-main-row         { flex-direction: column; gap: 48px; }
    .svt-sidebar          { flex: none; width: 100%; }
    .svt-article-title    { font-size: 20px; }
  }

  /* ══ RESPONSIVE — MOBILE ══ */
  @media (max-width: 480px) {
    .svt-hero             { height: 360px; }
    .svt-hero-content     { padding: 0 16px; }
    .svt-hero-title       { font-size: 24px; margin-bottom: 15px; }
    .svt-hero-divider     { width: 100%; }
    .svt-hero-subtitle    { font-size: 14px; }
    .svt-breadcrumb       { padding: 30px 0 0 0; }
    .svt-breadcrumb-inner { padding: 0 16px; }
    .svt-bc-item          { font-size: 14px; gap: 14px; }
    .svt-bc-sep           { width: 18px; height: 18px; margin: 0 4px; }
    .svt-bc-sep img       { width: 22px; height: 22px; }
    .svt-inner            { padding: 0 16px; }
    .svt-main-section     { padding: 30px 0 60px 0; }
    .svt-main-row         { flex-direction: column; gap: 60px; }
    .svt-sidebar          { flex: none; width: 100%; }
    .svt-article-title    { font-size: 20px; margin-bottom: 15px; }
    .svt-article-body     { font-size: 14px; }
    .svt-article-body p   { margin-bottom: 15px; }
    .svt-article-body ul  { margin: 0 0 20px 0; gap: 10px; }
    .svt-article-body ul li { font-size: 14px; }
    .svt-meta-item        { font-size: 14px; }
    .svt-article-img      { margin: 30px 0 15px 0; height: 250px; }
    .svt-h2               { font-size: 16px; margin: 30px 0 15px 0; }
    .svt-h3               { font-size: 14px; margin: 15px 0 10px 0; }
    .svt-nav-btn img      { width: 24px; height: 24px; }
    .svt-nav-btn          { font-size: 14px; }
    .svt-share-icon img   { width: 34px; height: 34px; }
    .svt-sidebar-title    { font-size: 20px; }
    .svt-hashtags         { margin-top: 30px; }
  }
`;

const recentPosts = [
   {
       img: RecentImg1,
       title: "Battery Formation & Testing: Enabling The Rise Of EV & Energy Storage Manufacturing",
       slug: "battery-formation-testing-enabling-the-rise-of-ev-energy-storage-manufacturing/",
     },
     {
       img: RecentImg2,
       title: "Next-Gen ESP Power Supplies: Upgrades and Sustainability in Industrial Air Pollution Control",
       slug: "next-gen-esp-power-supplies-upgrades-and-sustainability-in-industrial-air-pollution-control/",
     },
     {
       img: RecentImg3,
       title: "Green Hydrogen Power Electronics: Ador Powertron at the Forefront of Electrolyzer Rectifier Setups",
       slug: "green-hydrogen-power-electronics-ador-powertron-at-the-forefront-of-electrolyzer-rectifier-setups/",
     },
     {
       img: RecentImg4,
       title: "Transformer Bushings: Types & Importance",
       slug: "transformer-bushings-guide/",
     },
];

export default function SMPSvsTraditionalPowerSupplies() {
  return (
    <div className="svt">
      <style>{CSS}</style>

      {/* ══ HERO ══ */}
      <section className="svt-hero">
        <img className="svt-hero-bg" src={HeroBgImg} alt="SMPS vs Traditional Hero" />
        <div className="svt-hero-overlay" />
        <div className="svt-hero-content">
          <h1 className="svt-hero-title">
            SMPS vs. Traditional Power Supplies: A Comprehensive Comparison
          </h1>
          <hr className="svt-hero-divider" />
          <p className="svt-hero-subtitle">
            Everything we do is designed, whether we're producing a magazine, a website, or a bridge. Design is really the creative invention that designs everything.
          </p>
        </div>
      </section>

      {/* ══ BREADCRUMB ══ */}
      <nav className="svt-breadcrumb" aria-label="Breadcrumb">
        <div className="svt-breadcrumb-inner">
          <a href="/" className="svt-bc-item">Home</a>
          <span className="svt-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <a href="/news" className="svt-bc-item">News &amp; Updates</a>
          <span className="svt-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <span className="svt-bc-item active">Post</span>
        </div>
      </nav>

      {/* ══ MAIN ══ */}
      <section className="svt-main-section">
        <div className="svt-inner">
          <div className="svt-main-row">

            {/* ── ARTICLE ── */}
            <article className="svt-article">

              {/* Meta bar */}
              <div className="svt-meta-bar">
                <span className="svt-meta-item"><img src={ProfileIcon} alt="author" /> Admin</span>
                <span className="svt-meta-item"><img src={CalendarIcon} alt="date" /> January 24, 2025</span>
                <span className="svt-meta-item"><img src={ClockIconImg} alt="time" /> 11:01 am</span>
                <span className="svt-meta-item"><img src={CommentsIcon} alt="comments" /> No Comments</span>
              </div>

              {/* Title */}
              <h1 className="svt-article-title">
                SMPS vs. Traditional Power Supplies: A Comprehensive Comparison
              </h1>

              {/* Body */}
              <div className="svt-article-body">

                <p>Substantial improvements have occurred over the years, with the Switch-Mode Power Supply (SMPS) appearing as a chosen solution across diverse enterprises. But how are they different from traditional power supplies? What are their USPs? Understanding the dissimilarities between SMPS and linear power supplies is crucial for enterprises and industries seeking efficiency and performance.</p>

                {/* Article image */}
                <img className="svt-article-img" src={ArticleImg} alt="SMPS vs Traditional Power Supplies" />

                <p>Let us understand why SMPS converts industries from hydrogen generation to cutting-edge manufacturing systems.</p>

                <span className="svt-h2">What Is SMPS?</span>

                <p><a href="" className="svt-red-link">Switch Mode Power Supply</a> (SMPS) is an evolved power conversion technology that utilizes high-frequency switching to control voltage and current. Unlike traditional linear power supplies, SMPS delivers enhanced efficiency, compactness, and versatility, making it a favored alternative for contemporary applications.</p>

                <span className="svt-h2">Critical Contrasts between SMPS and Traditional Power Supplies</span>

                <p>Let's dive into a side-by-side comparison of SMPS and traditional linear power supplies across critical parameters:</p>

                <span className="svt-h3"> 1. Efficiency</span>

                <ul>
                  <li><span>SMPS: Operates up to 90% efficiency by minimizing energy loss during conversion. The high-frequency switching decreases heat generation, providing more power to the load.</span></li>
                  <li><span>Traditional Power Supply: Normally functions at 50%-60% efficiency, yielding substantial energy as heat during voltage regulation.</span></li>
                </ul>

                <p><strong>Why It Matters:</strong> Higher efficiency in <a href="" className="svt-red-link-plain">SMPS power</a> results in inferior energy consumption, decreased operational expenses, and less environmental impact.</p>

                <span className="svt-h3"> 2. Size and Weight</span>

                <ul>
                  <li><span>SMPS: Compact and lightweight due to smaller transformers and high-frequency components.</span></li>
                  <li><span>Traditional Power Supply: Bulky and heavy because of large transformers and heat sinks required for operation.</span></li>
                </ul>

                <p><strong>Why It Matters:</strong> SMPS's compact size is ideal for applications where space is a constraint, such as portable devices or advanced hydrogen power sources.</p>

                <span className="svt-h3"> 3. Heat Dissipation</span>

                <ul>
                  <li><span>SMPS: Generates minimal heat thanks to its efficient switching mechanism.</span></li>
                  <li><span>Traditional Power Supply: Produces significant heat, requiring larger heat sinks and cooling mechanisms.</span></li>
                </ul>

                <p><strong>Why It Matters:</strong> Lower heat dissipation in SMPS reduces the risk of overheating, increases system reliability, and lowers cooling costs.</p>

                <span className="svt-h3"> 4. Input Voltage Range</span>

                <ul>
                  <li><span>SMPS: Handles a wide range of input voltages, making it adaptable to varying power conditions.</span></li>
                  <li><span>Traditional Power Supply: Operates within a narrow input voltage range, limiting its flexibility.</span></li>
                </ul>

                <p><strong>Why It Matters:</strong> SMPS is better suited for applications in regions with unstable power grids or industries with dynamic power requirements.</p>

                <span className="svt-h3"> 5. Applications</span>

                <ul>
                  <li><span>SMPS: Widely used in advanced technologies, including industrial systems, telecommunications, renewable energy, and hydrogen generation.</span></li>
                  <li><span>Traditional Power Supply: This power supply is commonly found in older devices or applications that have unnecessary high-frequency operation.</span></li>
                </ul>

                <span className="svt-h2">Why It Matters</span>

                <p>SMPS aligns with current industrial needs, delivering versatility for cutting-edge applications like Ador's SMPS power solutions.</p>

                <span className="svt-h2">Benefits of SMPS over Traditional Power Supplies</span>

                <ul>
                  <li><span><strong>Energy Efficiency:</strong> Decreases power loss, making it cost-effective and eco-friendly.</span></li>
                  <li><span><strong>Packed Design:</strong> Preserves space in installations and enhances portability.</span></li>
                  <li><span><strong>Broad Voltage Compatibility:</strong> It adapts to varying input conditions, ensuring stability.</span></li>
                  <li><span><strong>Enhanced Performance:</strong> Provides consistent and reliable power output.</span></li>
                  <li><span><strong>Scalability:</strong> Suitable for applications ranging from small devices to large-scale industrial systems.</span></li>
                </ul>

                <span className="svt-h2">Applications of SMPS in Advanced Industries</span>

                <span className="svt-h3"> 1. Consumer ElectronicsConsumer Electronics</span>
                <p>SMPS powers devices like laptops, smartphones, and TVs, presenting reliability and energy efficiency.</p>

                <span className="svt-h3"> 2. Renewable Energy Systems</span>
                <p>SMPS is used in solar inverters and wind turbines to guarantee seamless energy conversion for sustainable solutions.</p>

                <span className="svt-h3"> 3. Hydrogen Generation</span>
                <p>At Ador, SMPS power is integral to our Power Conversion Units, ensuring efficient and consistent power delivery for electrolysers used in hydrogen production.</p>

                <span className="svt-h3"> 4. Industrial Automation</span>
                <p>SMPS supports automation by providing stable power to critical control systems and equipment.</p>

                <span className="svt-h2">Challenges of SMPS vs. Traditional Power Supplies</span>

                <p>While SMPS offers numerous benefits, it does come with challenges:</p>

                <ul>
                  <li><span><strong>Complex Design:</strong> Requires more advanced circuitry, increasing design complexity.</span></li>
                  <li><span><strong>Electromagnetic Interference (EMI):</strong> High-frequency switching can introduce noise, requiring additional filtering components.</span></li>
                  <li><span><strong>Cost:</strong> SMPS's initial manufacturing costs can be higher than those of traditional power supplies, though the operational savings offset this over time.</span></li>
                </ul>

                <p>Despite these challenges, SMPS power's benefits make it the superior choice for industries seeking performance, reliability, and efficiency.</p>

                <span className="svt-h2">Why Choose SMPS with Ador?</span>

                <p>Ador's expertise in <strong>power electronics</strong> and devotion to invention make us a leader in <strong>SMPS power</strong> solutions. Our <strong>SMPS power supplies</strong> are devised to fulfill the requirements of demanding applications, from hydrogen generation to renewable energy systems.</p>

                <span className="svt-h2">Final Thoughts</span>

                <p>While traditional power supplies served their objective in the past, SMPS's superior efficiency, compactness, and adaptability make it the technology of preference for current industries. Whether powering cutting-edge devices or industrial systems, SMPS guarantees reliability, performance, and sustainability.</p>

                <p>Ready to boost your power systems? Contact us today to explore our cutting-edge <strong>SMPS solutions</strong> and take the first step toward a more efficient, energy-conscious tomorrow.</p>

                <p className="svt-hashtags">#SMPS #PowerElectronics #EnergyEfficiency #SustainableTech #SwitchModePowerSupply</p>

              </div>

              {/* ── Bottom row ── */}
              <div className="svt-bottom-row">
                <div className="svt-bottom-nav">
                  <a href="/news/how-switch-mode-power-supply-improves-energy-efficiency" className="svt-nav-btn">
                    <img src={PreviousIcon} alt="Previous" />
                    Previous
                  </a>
                  <a href="/news/adorpowertron-smps-cuts-energy-consumption" className="svt-nav-btn">
                    Next
                    <img src={NextIcon} alt="Next" />
                  </a>
                </div>
                <div className="svt-share-icons">
                  <a href="https://www.facebook.com/sharer.php?u=https://adorpowertron.com/smps-vs-traditional-power-supplies-a-comprehensive-comparison/" className="svt-share-icon" aria-label="Facebook" target="blank">
                    <img src={FacebookIcon} alt="Facebook" />
                  </a>
                  <a href="https://x.com/i/jf/onboarding/web?redirect_after_login=%2Fintent%2Ftweet%3Ftext%3D%2520https%3A%2F%2Fadorpowertron.com%2Fsmps-vs-traditional-power-supplies-a-comprehensive-comparison%2F&mode=login" className="svt-share-icon" aria-label="Twitter" target="blank">
                    <img src={TwitterIcon} alt="Twitter" />
                  </a>
                  <a href="https://www.linkedin.com/login/?session_redirect=https%3A%2F%2Fwww.linkedin.com%2FshareArticle%3Fmini%3Dtrue%26url%3Dhttps%3A%2F%2Fadorpowertron.com%2Fsmps-vs-traditional-power-supplies-a-comprehensive-comparison%2F%26title%3DSMPS%2520vs%2520Traditional%2520Power%2520Supplies%2520%257C%2520Ador%26summary%3D%26source%3Dhttps%3A%2F%2Fadorpowertron.com%2Fsmps-vs-traditional-power-supplies-a-comprehensive-comparison%2F" className="svt-share-icon" aria-label="LinkedIn" target="blank">
                    <img src={LinkedinShareIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </article>

            {/* ── SIDEBAR ── */}
            <aside className="svt-sidebar">

              {/* Recent Posts */}
              <div className="svt-sidebar-block">
                <p className="svt-sidebar-title">Recent Posts</p>
                <div className="svt-recent-list">
                  {recentPosts.map((post, idx) => (
                    <a key={idx} href={`/news/${post.slug}`} className="svt-recent-item">
                      <img src={post.img} alt={post.title} className="svt-recent-img" />
                      <div className="svt-recent-body">
                        <span className="svt-recent-title">{post.title}</span>
                      </div>
                    </a>
                  ))}
                </div>
              </div>

              {/* Social Media */}
              <div className="svt-sidebar-block">
                <p className="svt-sidebar-title">Social Media</p>
                <div className="svt-social-icons">
                  <a href="https://www.youtube.com/@adorIndia" className="svt-social-icon" aria-label="YouTube" target="blank">
                    <img src={YoutubeIcon} alt="YouTube" />
                  </a>
                  <a href="https://www.linkedin.com/uas/login?session_redirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2F139191%2Fadmin%2F" className="svt-social-icon" aria-label="LinkedIn" target="blank">
                    <img src={LinkedinIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </aside>

          </div>
        </div>
      </section>

    </div>
  );
}